import { Error } from '@progress/kendo-react-labels'
import React from 'react'
import { send } from '../../service'
import { debounce } from "lodash";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';

export const FibaDropdownInput = (fieldRenderProps) => {
  const {
    validationMessage,
    visited,
    required,
    label,
    fieldInfo,
    disabled,
    name,
    modified,
    valid,
    touched,
    cyrillic2latin,
    render,
    ddata,
    dwidth = '40%',
    textField = 'name', valueField = 'value',
    onResult,
    ...others
  } = fieldRenderProps
  let value = fieldRenderProps.value;
  const cyrillic2latinFunction = async (event) => {
    if (others.onKeyUp) {
      others.onKeyUp(event);
    }
    if (cyrillic2latin && render) {
      const res = await send('gp040102', { name: event.target.value });
      if (res.status !== 'error') {
        render.onChange(cyrillic2latin, { value: res })
      }
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedChangeHandler = React.useCallback(debounce(cyrillic2latinFunction, 300), []);

  React.useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    }
  }, [debouncedChangeHandler]);
  // console.log(ddata)
  const [data, setData] = React.useState(ddata.slice());
  const [dvalue, setdValue] = React.useState();
  const [prefvalue, setPrefValue] = React.useState();
  const [tmpprefvalue, setTempPrefValue] = React.useState();

  const filterData = (filter) => {
    const data = ddata.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event) => {
    setData(filterData(event.filter));
  };

  const dhandleChange = (event) => {
    const tmpvalue = event.target.value;
    setdValue(tmpvalue);
    if (tmpvalue) {
      setTempPrefValue(prefvalue)
      setPrefValue(tmpvalue[valueField])
      if (onResult) {
        onResult(tmpvalue)
      }
      if (fieldRenderProps.onChange) {
        fieldRenderProps.onChange({ value: tmpvalue[valueField] })
      }
    }
  }
  if (prefvalue) {
    if (value) {
      if (tmpprefvalue && !(value + "").startsWith(tmpprefvalue)) {
        value = (value + "").substr(tmpprefvalue.length);
      }
      if (!(value + "").startsWith(prefvalue)) {
        value = prefvalue + value;
      }
    }
  }

  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className='k-required'>*</span>}
        {fieldInfo && <span className='k-field-info'>{fieldInfo}</span>}
      </label>
      <div className={`mt-1`}>
        <div className="flex">
          <div className={`inline-flex items-center text-sm text-gray-900 bg-gray-200 border-r-0 border-gray-300 rounded-l-md`}
            style={{ width: dwidth }}
          >
            <DropDownList
              data={data}
              onFilterChange={filterChange}
              textField={textField}
              dataItemKey={valueField}
              filterable={true}
              value={dvalue}
              onChange={dhandleChange}
              disabled={disabled}
              style={{
                borderTopRightRadius: '0px',
                borderBottomRightRadius: '0px',
                width: '100%',
                minWidth: '100px'
              }}
            />
          </div>
          <input
            required={required}
            disabled={disabled}
            modified={modified ? modified + "" : ""}
            touched={touched ? touched + "" : ""}
            valid={valid ? valid + "" : ""}
            className="k-input k-input-md k-input-solid rounded-l-none"
            onKeyUp={debouncedChangeHandler}
            name={name}
            {...others}
            value={value || ''}
            style={{
              width: '100%',
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
            }}
          />
        </div>

        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    </div>

  )
}
